import { fabric } from 'fabric';
import CanvasObject from "./CanvasObject";
import Canvas from "./../Canvas";
import apiRequestHelper from "./../../api/requestHelper";
import AppDebug from "./../../AppDebug";
import ImageObject from "./ImageObject";

class ImageLimitedFormObject extends ImageObject {

    static TYPE_TITLE = 'image_limited_form';

    getDisabledOnForm() {
        return ['left', 'top', 'angle'];
    }

    async createFabricObject() {
        const fabricObject = await super.createFabricObject();
        fabricObject.setControlVisible('ml', false);
        fabricObject.setControlVisible('mr', false);
        fabricObject.setControlVisible('mt', false);
        fabricObject.setControlVisible('mb', false);
        return fabricObject;
    }

}

export default ImageLimitedFormObject;
